import { Button, Form, notification, Row } from 'antd';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import { getLastValueFromList } from '../../../helpers/array';
import { showErrors } from '../../../helpers/form';
import apiShipper from '../../../services/apiShipper';
import TarifasCliente from './TarifasCliente';

export default function Monetizacao({ cliente }) {
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const [form] = Form.useForm();
  const [tarifas, setTarifas] = useState([]);

  const [inputTarifa, setInputTarifa] = useState(true);

  useEffect(() => {
    async function onInit() {
      if (!cliente) return;

      const tarifasCliente = cliente.tarifas || [];

      setInputTarifa(cliente.tipo_tarifa_tmov === 'PERCENTUAL');
      setTarifas(tarifasCliente);
      // preenche os inputs com as informações recuperadas
      form.setFieldsValue({
        tarifaInicial: getLastValueFromList(tarifasCliente)?.valor_inicial || 0,
      });
    }

    onInit();
  }, [form, cliente, history]);

  const handleSubmitClient = async () => {
    setLoading(true);

    if (tarifas.length === 0) {
      setLoading(false);
      return showErrors([
        'O cliente precisa ter pelo menos uma faixa de tarifa',
      ]);
    }

    try {
      await apiShipper.put(`/clientes/${cliente.id}`, {
        ...cliente,
        tarifas,
        tipo_tarifa_tmov: inputTarifa ? 'PERCENTUAL' : 'REAIS',
      });

      history.push('/clientes');

      notification.success({
        message: 'Tudo certo',
        description: 'O cliente foi atualizado com sucesso.',
      });
    } catch (error) {
      const errors = error?.response?.data?.errors
        ? Object.values(error?.response?.data?.errors)
        : null;

      showErrors(errors);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Form layout="vertical" onFinish={handleSubmitClient} form={form}>
        <TarifasCliente
          form={form}
          tarifas={tarifas}
          setTarifas={setTarifas}
          inputTarifa={inputTarifa}
          setInputTarifa={setInputTarifa}
        />

        <Row justify="end" className="mt-20">
          <Button loading={loading} type="primary" htmlType="submit">
            Salvar
          </Button>
        </Row>
      </Form>
    </>
  );
}

Monetizacao.propTypes = {
  cliente: PropTypes.objectOf(PropTypes.any).isRequired,
};
